import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    // On initial page load, sync localStorage with the user's saved theme
    const userTheme = document.documentElement.dataset.theme
    if (userTheme) {
      localStorage.setItem('theme', userTheme)
    }

    // If there's a theme in localStorage (from another tab/window), use it
    const storedTheme = localStorage.getItem('theme')
    if (storedTheme) {
      document.documentElement.setAttribute('data-theme', storedTheme)
    } else {
      // No stored theme — follow OS preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      const osTheme = prefersDark ? 'dark' : 'light'
      document.documentElement.setAttribute('data-theme', osTheme)
    }

    // Listen for theme changes from other tabs/windows
    this.boundHandleStorageChange = this.handleStorageChange.bind(this)
    window.addEventListener('storage', this.boundHandleStorageChange)

    // Listen for OS theme preference changes
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    this.boundHandleMediaChange = this.handleMediaChange.bind(this)
    this.mediaQuery.addEventListener('change', this.boundHandleMediaChange)
  }

  disconnect() {
    window.removeEventListener('storage', this.boundHandleStorageChange)
    this.mediaQuery.removeEventListener('change', this.boundHandleMediaChange)
  }

  handleStorageChange(event) {
    if (event.key === 'theme' && event.newValue) {
      document.documentElement.setAttribute('data-theme', event.newValue)
    }
  }

  handleMediaChange(event) {
    // Only respond to OS changes if the user hasn't explicitly chosen a theme
    if (!localStorage.getItem('theme')) {
      const osTheme = event.matches ? 'dark' : 'light'
      document.documentElement.setAttribute('data-theme', osTheme)
    }
  }
}
